<sm-title-bar [pageTitle]="isEntityForeign == '0' ? 'Tax & GST' : 'Tax Setup'" *ngIf="!loader" [headerCustomTemplate]="addButton" [backWithParams]="true">
  <ng-template #addButton>
  <div class="create_btn_sd" *ngIf="toShowCheck === 1">
    <!-- <button mat-icon-button aria-label="option menu"  color="accent" (click)="opennewconfigureTax()">
      <mat-icon>settings</mat-icon>
    </button> -->
     <div class="">
      <button mat-icon-button [matMenuTriggerFor]="menu2" aria-label="Example icon-button with a menu">
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu2="matMenu">
  <button mat-menu-item (click)="opennewconfigureTax()">
    <mat-icon>settings</mat-icon>
    <span>Configure tax</span>
  </button>
</mat-menu>
    </div>
</div>
  </ng-template>
</sm-title-bar>


<div class="merchant_detail_sec" >
  <div class="mrt_offe">
    <div class="row">
      <div class="col-sm-12">
        <div class="drt_head">
        </div>

        <div class="list_user" *ngIf="loader == false && isEntityForeign == '0'">
          <a href="javascript:void(0)" class="admin_category">
            <div class="card_header chead">
              <div class="adm_set">
                <div>
                  <span class="name_cont">Tax collection</span>
                  <div class="tax_gst_section">
                  
                    <div class="toogle_cldf">
                  <mat-slide-toggle class="share" (change)="onToggleChange($event)" [checked]="toShowCheck === 1"></mat-slide-toggle>
                </div>
                </div>
                  <h2 style="color: #666666;
                  padding-top: 0px;
                  margin-top: 2px;
                  margin-bottom: 14px;
                  font-size: 14px;" *ngIf="toShowCheck === 1">Tax is enabled.</h2>
                  <h2 style="color: #666666;
                  padding-top: 0px;
                  margin-top: 2px;
                  margin-bottom: 8px;
                  font-size: 14px;" *ngIf="toShowCheck === 0"> Tax is disabled.</h2>
                  <h4 style="margin-bottom: 20px;">Setup GST, Service tax or any other local tax here, if you are adding tax in your invoice, enable that from here. Also if you aren't, then leave it as disabled. Recording taxes on invoices helps both the seller and the buyer maintain accurate financial records. Businesses can track the amount of tax collected and owed to tax authorities. You can see the detail data on tax paid in Reports section.
                  </h4>

                <div class="tax_isd_section" *ngIf="toShowCheck === 1">
                  <div class="idficv_sectionm">
                  <h2>Tax identifiers</h2>
                  <p>Government and local tax ids</p>
                </div>
                <div class="edit_tht_edit">
                  <div class="brfg_sett_open">
                    <span (click)="openDomesticTaxConfig()">
                      <mat-icon class="material-icons-outlined">edit</mat-icon>
                    </span>
                  </div>`
                </div>
                </div>

                </div>
              </div>
              <div class="tax_grt_open" *ngIf="toShowCheck === 1">
              <div class="row">
                <div class="col-sm-6 col-md-6 col-12">
                  <div class="service_listh">
                      <div class="bus_icon">
                       <mat-icon>recent_actors</mat-icon>
                      </div>
                      <div class="bus_hjk">
                          <h4>PAN Card Number</h4>
                          <p>{{taxData[0]?.pan_number ? taxData[0]?.pan_number : '---'}}</p>
                        
                      </div>
                  </div>
              </div>
                
                <div class="col-sm-6 col-md-6 col-12">
                  <div class="service_listh">
                      <div class="bus_icon">
                       <mat-icon>recent_actors</mat-icon>
                      </div>
                      <div class="bus_hjk">
                          <h4>TAN Number</h4>
                          <p>{{taxData[0]?.tan_number ? taxData[0]?.tan_number : '---'}}</p>
                        
                      </div>
                  </div>
              </div>
                <div class="col-sm-6 col-md-6 col-12">
                  <div class="service_listh" style="border-right: none !important;">
                      <div class="bus_icon">
                       <mat-icon>recent_actors</mat-icon>
                      </div>

                      <div class="bus_hjk">
                          <h4>GST Number</h4>
                          <p>{{taxData[0]?.gst_number ? taxData[0]?.gst_number : '---'}}</p>
                        
                      </div>

                   

                  </div>
              </div>
              </div>

              <div class="tax_isd_section" style="margin-bottom: 32px;">
                <div class="idficv_sectionm">
                <h2>Bill / Invoice type
                </h2>
                <p>Inclusion of tax in bill or invoice
                </p>
              </div>
              <div class="edit_tht_edit">
                <div class="brfg_sett_open">
                  <span (click)="openbillinvoicetype(0)">
                    <mat-icon class="material-icons-outlined">edit</mat-icon>
                  </span>
                </div>
              </div>
              </div>

              <div class="row">
                <div class="col-sm-6 col-md-6 col-12" *ngIf="taxData[0]?.bill_invoice_type">
                  <div class="service_listh" style="padding-left: 20px;" *ngIf="taxData[0]?.bill_invoice_type == 1">
                      <div class="bus_icon">
                       <mat-icon style="color: #09c00d;">check_circle</mat-icon>
                      </div>
                      <div class="bus_hjk">
                          <h4>Tax included in the selling price</h4>
                          <p>TAX INCLUSIVE </p>
                      </div>
                  </div>
                  <div class="service_listh" style="padding-left: 20px;" *ngIf="taxData[0]?.bill_invoice_type == 2">
                      <div class="bus_icon">
                        <mat-icon style="color: #09c00d;">check_circle</mat-icon>
                      </div>
                      <div class="bus_hjk">
                          <h4>Tax added extra in selling price</h4>
                          <p>TAX EXCLUSIVE </p>
                      </div>
                  </div>
              </div>
              </div>



            </div>
              <!-- (click)="configureTax()" -->
              <!-- opennewconfigureTax -->
              <!-- <div class="create_btn_sd" *ngIf="toShowCheck === 1" >
                <button mat-button aria-label="option menu"  color="accent" (click)="opennewconfigureTax()">
                  Configure Tax & GST
                </button>
            </div> -->
              <!-- <div class="create_btn_sd">
                <button mat-button aria-label="option menu"  color="accent" (click)="opennewconfigureTax()">
                  Configure Tax & GST
                </button>
            </div> -->
            </div>

          </a>
<!-- NEW TRAIL DESIGN -->
      <div *ngIf="toShowCheck === 1">
          <div class="service_info" *ngFor="let item of taxSlabsData; let i = index">
            <div class="row">
              <div class="col-sm-12" style="position: relative;">
                <mat-icon class="share2 material-icons-outlined" (click)="onRedirectToConfig(i)">edit</mat-icon>
                  <!-- <mat-slide-toggle class="share2" (change)="onToggleChangeOfSlab($event,item)" [checked]="item.tax_collection_status === 1"></mat-slide-toggle> -->
                    <div class="serv_seingo2">
                        <h3>{{item.tax_name}}</h3>
                    </div>
                </div>
              
            <!-- <hr class="discoutnt_vv"> -->
            <div class="col-6" *ngIf="item?.cgst_status && item?.cgst_status != 'null' && item?.cgst_status != 0">
              <div class="service_listh">
                  <div class="bus_icon">
                      <mat-icon>list_alt</mat-icon>
                  </div>
                  <div class="bus_hjk">
                      <h4> CGST </h4>
                      <p>  {{item.cgst_value}}% </p>
                  </div>
              </div>
          </div>
          <div class="col-6" *ngIf="item?.igst_status && item?.igst_status != 'null' && item?.igst_status != 0">
            <div class="service_listh">
                <div class="bus_icon">
                    <mat-icon>list_alt</mat-icon>
                </div>
                <div class="bus_hjk">
                    <h4> IGST </h4>
                    <p> {{item.igst_value}}% </p>
                </div>
            </div>
        </div>
          <div class="col-6" *ngIf="item?.sgst_status && item?.sgst_status != 'null' && item?.sgst_status != 0">
            <div class="service_listh" style="border-right: none;">
                <div class="bus_icon">
                    <mat-icon>list_alt</mat-icon>
                </div>
                <div class="bus_hjk">
                    <h4> SGST </h4>
                    <p> {{item.sgst_value}}% </p>
                </div>
            </div>
        </div>
        <!-- <hr class="discoutnt_vv"> -->
          <div class="col-6" *ngIf="item?.utgst_status && item?.utgst_status != 'null' && item?.utgst_status != 0">
            <div class="service_listh">
                <div class="bus_icon">
                    <mat-icon>list_alt</mat-icon>
                </div>
                <div class="bus_hjk">
                    <h4> UTGST </h4>
                    <p> {{item.utgst_value}}% </p>
                </div>
            </div>
        </div>
        <div class="col-6" *ngIf="item?.service_tax_status && item?.service_tax_status != 'null' && item?.service_tax_status != 0">
          <div class="service_listh" >
              <div class="bus_icon">
                  <mat-icon>list</mat-icon>
              </div>
              <div class="bus_hjk">
                  <h4> Service Tax </h4>
                  <p>   {{item.service_tax_value}}%   </p>
              </div>
          </div>
        </div>
        <div class="col-6" *ngIf="item?.other_tax_status && item?.other_tax_status != 'null' && item?.other_tax_status != 0">
          <div class="service_listh" style="border-right: none;">
              <div class="bus_icon">
                  <mat-icon>list</mat-icon>
              </div>
              <div class="bus_hjk">
                  <h4> {{item.other_tax_name}} </h4>
                  <p>   {{item.other_tax}}%   </p>
              </div>
          </div>
        </div>
            </div>
           </div>
</div>



        </div>

        <div class="list_user" *ngIf="loader == false && isEntityForeign == '1'">
          <a href="javascript:void(0)" class="admin_category">
            <div class="card_header chead">
              <div class="adm_set">
                <div>
                  <span class="name_cont">Tax collection</span>
                  <div class="tax_gst_section">
                    <!-- <div class="brfg_sett_open">
                      <span (click)="openInternationalTaxConfig()"><mat-icon class="material-icons-outlined">border_color</mat-icon></span>
                        </div> -->
                  <div class="toogle_cldf">
                  <mat-slide-toggle class="share" (change)="onToggleChange($event)" [checked]="toShowCheck === 1"></mat-slide-toggle>
                </div>
             
                </div>
                  <h2 style="color: #666666;
                  padding-top: 0px;
                  margin-top: 2px;
                  margin-bottom: 14px;
                  font-size: 14px;"  *ngIf="toShowCheck === 1">Tax is enabled.</h2>
                  <h2 style="color: #666666;
                  padding-top: 0px;
                  margin-top: 2px;
                  margin-bottom: 8px;
                  font-size: 14px;" *ngIf="toShowCheck === 0"> Tax is disabled.</h2>
                  <h4 style="margin-bottom: 20px;">Setup your tax here, if you are adding tax in your invoice, enable that from here. Also if you aren't, then leave it as disabled. Recording taxes on invoices helps both the seller and the buyer maintain accurate financial records. Businesses can track the amount of tax collected and owed to tax authorities. You can see the detail data on tax paid in Reports section.
                  </h4>
                </div>
                <div class="tax_isd_section" style="margin-bottom: 20px;" *ngIf="toShowCheck === 1">
                  <div class="idficv_sectionm">
                  <h2>Tax identifiers</h2>
                  <p>Government and local tax ids</p>
                </div>
                <div class="edit_tht_edit">
                  <div class="brfg_sett_open">
                    <span (click)="openInternationalTaxConfig()">
                      <mat-icon class="material-icons-outlined">edit</mat-icon>
                    </span>
                  </div>
                </div>
                </div>
              </div>
              <div class="row" *ngIf="toShowCheck === 1">
                <div class="col-sm-4" *ngFor="let item of taxData[0].tax_types">
                  <div class="service_listhyuhh">
                      <div class="bus_icon">
                       <mat-icon>recent_actors</mat-icon>
                      </div>
                      <div class="bus_hjk">
                          <h4>{{item.taxation_type}}</h4>
                          <p>{{item.identification_no}} </p>
                          
                      </div>
                  </div>
              </div>
              </div>

              <div class="tax_isd_section" style="margin-bottom: 32px;" *ngIf="toShowCheck === 1">
                <div class="idficv_sectionm">
                <h2>Bill / Invoice type
                </h2>
                <p>Inclusion of tax in bill or invoice
                </p>
              </div>
              <div class="edit_tht_edit">
                <div class="brfg_sett_open">
                  <span (click)="openbillinvoicetype(1)">
                    <mat-icon class="material-icons-outlined">edit</mat-icon>
                  </span>
                </div>
              </div>
              </div>

              <div class="row" *ngIf="toShowCheck === 1">
                <div class="col-sm-4" *ngIf="taxData[0]?.bill_invoice_type">
                  <div class="service_listh" style="padding-left: 20px;" *ngIf="taxData[0]?.bill_invoice_type == 1">
                    <div class="bus_icon">
                     <mat-icon style="color: #09c00d;">check_circle</mat-icon>
                    </div>
                    <div class="bus_hjk">
                        <h4>Tax included in the selling price</h4>
                        <p>TAX INCLUSIVE </p>
                    </div>
                </div>
                <div class="service_listh" style="padding-left: 20px;" *ngIf="taxData[0]?.bill_invoice_type == 2">
                    <div class="bus_icon">
                      <mat-icon style="color: #09c00d;">check_circle</mat-icon>
                    </div>
                    <div class="bus_hjk">
                        <h4>Tax added extra in selling price</h4>
                        <p>TAX EXCLUSIVE </p>
                    </div>
                </div>
              </div>
              </div>


              <!-- (click)="configureTax()" -->
              <!-- opennewconfigureTax -->
              <!-- <div class="create_btn_sd" *ngIf="toShowCheck === 1" >
                <button mat-button aria-label="option menu"  color="accent" (click)="opennewconfigureTax()">
                  Configure Tax
                </button>
            </div> -->
              <!-- <div class="create_btn_sd" >
                <button mat-button aria-label="option menu"  color="accent" (click)="opennewconfigureTax()">
                  Configure Tax
                </button>
            </div> -->
            </div>

          </a>
<!-- TRIAL DESIGN -->
 <div *ngIf="toShowCheck === 1">


<div class="service_info" *ngFor="let item of taxSlabsData; let i = index">
  <div class="row">
      <div class="col-sm-12">
        <mat-icon class="share2 material-icons-outlined" (click)="onRedirectToConfig(i)">edit</mat-icon>
        <!-- <mat-slide-toggle class="share2" (change)="onToggleChangeOfSlab($event,item)" [checked]="item.tax_collection_status === 1"></mat-slide-toggle> -->
          <div class="serv_seingo">
              <h3>{{item.slab_name ? item.slab_name : 'No slab name added'}}</h3>
          </div>
      </div>
      <!-- <div *ngIf="taxData[0].tax_types" style="border-bottom: 1px solid #ddd;
  margin-bottom: 20px;">
        <h3>Tax id types</h3>
        <div class="row">
          <div class="col-sm-4" *ngFor="let item of taxData[0].tax_types">
          <div class="service_listhyuhh">
              <div class="bus_icon">
               <mat-icon>recent_actors</mat-icon>
              </div>
              <div class="bus_hjk">
                  <h4>{{item.taxation_type}}</h4>
                  <p>{{item.identification_no}} </p>
                  
              </div>
          </div>
      </div>

        </div>

      </div> -->
      <div >
        <!-- <h3>Taxes</h3> -->
        <div class="row">
          <div class="col-sm-4" *ngFor="let element of item.tax_values">
          <div class="service_listhyuhh">
              <div class="bus_icon">
               <mat-icon>recent_actors</mat-icon>
              </div>
              <div class="bus_hjk">
                  <h4>{{element.tax_name}}</h4>
                  <p>{{element.tax_percentage}}% </p>
                  
              </div>
          </div>
      </div>
          

        </div>

      </div>

  </div>
 </div>
 </div>

        </div>

        








      </div>
      <!-- <div class="col-sm-1"></div> -->
    </div>
  </div>

</div>